import { useCallback } from 'react';
import useBrandActions from 'data/hooks/useBrandActions';
import { useSnackbar } from 'notistack';

const useConnect = (handleClose: () => void) => {
  const { unpause, isLoading } = useBrandActions();
  const { enqueueSnackbar } = useSnackbar();

  const handleEnable = useCallback(async () => {
    try {
      await unpause({});
      handleClose();
      enqueueSnackbar(`Status changed`, {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar(`Status change failed`, {
        variant: 'error',
      });
    }
  }, [unpause, handleClose, enqueueSnackbar]);

  return { handleEnable, isLoading };
};

export default useConnect;
